<template>
  <div id="defaultId1" class="company_detail" v-loading="loading">
    <div class="operations-box">
      <div class="operations-box-center margin-bottom10">
        <h2 class="operations-head operations-head-content">
          {{ $t("SearchTrade.TradeRanking") }}
        </h2>
        <div class="flex_center_start margin-bottom20">
          <ul class="flex_center Data-Management-ul">
            <li
              v-for="(item, index) in managementMenu"
              v-show="
                item.value == 3
                  ? suppliersFlag
                  : item.value == 4
                  ? buyersFlag
                  : item.value == 5
                  ? originFlag
                  : item.value == 6
                  ? destinationFlag
                  : item.value == 1
                  ? importFlag
                  : exportFlag
              "
              @click="
                (
                  item.value == 3
                    ? suppliersFlag
                    : item.value == 4
                    ? buyersFlag
                    : item.value == 5
                    ? originFlag
                    : item.value == 6
                    ? destinationFlag
                    : item.value == 1
                    ? importFlag
                    : exportFlag
                )
                  ? MenuClick(item)
                  : ''
              "
              :class="
                menuActive == item.value
                  ? 'menuActiveColor font18 font_bold'
                  : 'font18'
              "
              :key="index"
            >
              {{ item.label }}
            </li>
          </ul>
        </div>

        <div
          class="operations-box-head flex_center_bew"
          v-if="menuActive != '5' && menuActive != '6'"
        >
          <div class="operations-box-center-left">
            <h5 class="Byshipments">{{ $t("SearchTrade.Top5Ranking") }}</h5>

            <div class="Byshipments-table">
              <div
                class="line_step"
                v-for="(item, index) in tradeProductRankTop5DTO"
                :key="index"
              >
                <div class="txt flex_center_between_box">
                  <span
                    class="line_title CountryActive"
                    style="display: inline-block"
                    @click="setNews(item)"
                    >{{ index + 1 }}&nbsp; {{ item.value }}</span
                  >
                  <span class="blue_num" style="color: #8497ab"
                    >USD {{ item.totalAmount | FormatNum }}
                    <span v-if="item.growthRate != null">
                      (
                      <span
                        v-if="item.growthRate > 0 && item.growthRate"
                        style="color: #fb9f9f"
                        >+</span
                      ><span
                        v-if="item.growthRate < 0 && item.growthRate"
                        style="color: #009ea7"
                      ></span
                      ><span
                        :class="
                          item.growthRate < 0 ? 'Color009EA7' : 'Colorred'
                        "
                        >{{ item.growthRate + "%" }}</span
                      >)</span
                    ></span
                  >
                </div>
                <el-progress
                  color="#009EA7"
                  :stroke-width="10"
                  :show-text="false"
                  define-back-color="#DDDDDD"
                  :percentage="getProgress(item)"
                ></el-progress>
              </div>
            </div>
          </div>
          <div class="operations-box-center-left operations-box-center-right">
            <h5 class="Byshipments">{{ $t("SearchTrade.Growth") }}</h5>
            <div class="Byshipments-table">
              <div
                class="line_step"
                v-for="(item, index) in fastGrowthList"
                :key="index"
              >
                <div class="txt flex_center_between_box pb10">
                  <span
                    class="line_title CountryActive"
                    style="display: inline-block"
                    @click="setNews(item)"
                    >{{ index + 1 }}&nbsp; {{ item.value }}</span
                  >
                  <span class="blue_num" style="color: #8497ab"
                    >USD {{ item.totalAmount | FormatNum }}
                    <span v-if="item.growthRate != null">
                      (
                      <span
                        v-if="item.growthRate > 0 && item.growthRate"
                        style="color: #fb9f9f"
                        >+</span
                      ><span
                        v-if="item.growthRate < 0 && item.growthRate"
                        style="color: #009ea7"
                      ></span
                      ><span
                        :class="
                          item.growthRate < 0 ? 'Color009EA7' : 'Colorred'
                        "
                        >{{ item.growthRate + "%" }}</span
                      >)</span
                    ></span
                  >
                </div>
                <el-progress
                  color="#DDDDDD"
                  :stroke-width="1"
                  :show-text="false"
                  define-back-color="#DDDDDD"
                  :percentage="getProgress(item)"
                ></el-progress>
              </div>
            </div>
          </div>
        </div>
        <div
          class="operations-box-head flex_center_bew flex_center_bewTwo"
          v-if="menuActive == '5' || menuActive == '6'"
        >
          <div
            class="operations-box-center-left"
            v-if="tradeProductRankTop5DTO.length > 0"
          >
            <h5 class="Byshipments">{{ $t("SearchTrade.Top5Ranking") }}</h5>

            <div class="Byshipments-table">
              <div
                class="line_step"
                v-for="(item, index) in tradeProductRankTop5DTO"
                :key="index"
              >
                <div class="txt flex_center_between_box">
                  <span class="line_title CountryActive"
                    >{{ index + 1 }}&nbsp;
                    <img
                      class="margin-right10 margin-left10 line_img"
                      :src="item.img"
                      alt=""
                    />
                    <span class="CountryActive" @click="setCountry(item)">
                      {{ item.value }}</span
                    ></span
                  >
                  <span class="blue_num" style="color: #8497ab"
                    >USD {{ item.totalAmount | FormatNum }}
                    <span v-if="item.growthRate != null">
                      (
                      <span
                        v-if="item.growthRate > 0 && item.growthRate"
                        style="color: #fb9f9f"
                        >+</span
                      ><span
                        v-if="item.growthRate < 0 && item.growthRate"
                        style="color: #009ea7"
                      ></span
                      ><span
                        :class="
                          item.growthRate < 0 ? 'Color009EA7' : 'Colorred'
                        "
                        >{{ item.growthRate + "%" }}</span
                      >)</span
                    ></span
                  >
                </div>
                <el-progress
                  color="#009EA7"
                  :stroke-width="10"
                  :show-text="false"
                  define-back-color="#DDDDDD"
                  :percentage="getProgress(item)"
                ></el-progress>
              </div>
            </div>
          </div>
          <div
            class="operations-box-center-left"
            v-if="fastGrowthList.length > 0"
          >
            <h5 class="Byshipments">{{ $t("SearchTrade.Growth") }}</h5>

            <div class="Byshipments-table">
              <div
                class="line_step"
                v-for="(item, index) in fastGrowthList"
                :key="index"
              >
                <div class="txt flex_center_between_box pb10">
                  <span class="line_title CountryActive"
                    >{{ index + 1 }}&nbsp;
                    <img
                      class="margin-right10 margin-left10 line_img"
                      :src="item.img"
                      alt=""
                    />
                    <span class="CountryActive" @click="setCountry(item)">
                      {{ item.value }}</span
                    ></span
                  >
                  <span class="blue_num" style="color: #8497ab"
                    >USD {{ item.totalAmount | FormatNum }}
                    <span v-if="item.growthRate != null">
                      (
                      <span
                        v-if="item.growthRate > 0 && item.growthRate"
                        style="color: #fb9f9f"
                        >+</span
                      ><span
                        v-if="item.growthRate < 0 && item.growthRate"
                        style="color: #009ea7"
                      ></span
                      ><span
                        :class="
                          item.growthRate < 0 ? 'Color009EA7' : 'Colorred'
                        "
                        >{{ item.growthRate + "%" }}</span
                      >)</span
                    ></span
                  >
                </div>
                <el-progress
                  color="#DDDDDD"
                  :stroke-width="1"
                  :show-text="false"
                  define-back-color="#DDDDDD"
                  :percentage="getProgress(item)"
                ></el-progress>
              </div>
            </div>
          </div>
          <div
            class="operations-box-center-left operations-box-center-right"
            v-if="reduceRateList.length > 0"
          >
            <h5 class="Byshipments">{{ $t("SearchTrade.FastDecline") }}</h5>
            <div class="Byshipments-table">
              <div
                class="line_step"
                v-for="(item, index) in reduceRateList"
                :key="index"
              >
                <div class="txt flex_center_between_box pb10">
                  <span class="line_title"
                    >{{ index + 1 }}&nbsp;
                    <img
                      class="margin-right10 margin-left10 line_img"
                      :src="item.img"
                      alt=""
                    />

                    <span class="CountryActive" @click="setCountry(item)">
                      {{ item.value }}</span
                    >
                  </span>
                  <span class="blue_num" style="color: #8497ab"
                    >USD {{ item.totalAmount | FormatNum }}
                    <span v-if="item.growthRate != null">
                      (
                      <span
                        v-if="item.growthRate > 0 && item.growthRate"
                        style="color: #fb9f9f"
                        >+</span
                      ><span
                        v-if="item.growthRate < 0 && item.growthRate"
                        style="color: #009ea7"
                      ></span
                      ><span
                        :class="
                          item.growthRate < 0 ? 'Color009EA7' : 'Colorred'
                        "
                        >{{ item.growthRate + "%" }}</span
                      >)</span
                    ></span
                  >
                </div>
                <el-progress
                  color="#DDDDDD"
                  :stroke-width="1"
                  :show-text="false"
                  define-back-color="#DDDDDD"
                  :percentage="getProgress(item)"
                ></el-progress>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getTabListOneLayer } from "@/api/userApi.js";
import { getTradeTopDataByType } from "@/api/companyApi.js";

import { mixins1 } from "@/mixins/index";
export default {
  name: "",
  props: {},
  mixins: [mixins1],
  components: {},
  watch: {},

  data() {
    return {
      menuActive: 3,
      tradeProductRankTop5DTO: [],
      fastGrowthList: [],
      reduceRateList: [],

      suppliersFlag: false,
      buyersFlag: false,
      originFlag: false,
      destinationFlag: false,
      importFlag: false,
      exportFlag: false,
      loading: false,
    };
  },
  methods: {
    setCountry(item) {
      let routeData = this.$router.resolve({
        path:
          "/index/TradeCountry/TradeDetail/" +
          item.code +
          "/tradeMap/map?id3a=" +
          item.code +
          "&Tradechannel=HsCode" +
          "&Moudles=Trade",
      });
      window.open(routeData.href, "_blank");
    },
    // 点击跳转
    setNews(item) {
      if (this.menuActive == 3 || this.menuActive == 4) {
        let SACode1 = "";
        let routeData = this.$router.resolve({
          // Tradecompany/Trade/
          // /company/details
          path:
            "/index/tradeCompany/Trade/" +
            item.code +
            // "/background/snapshot?id3a=" +
            "/tradeMap/map?id3a=" +
            item.code +
            "&companyCountry=" +
            "" +
            "&SACode1=" +
            SACode1 +
            "&companyName=" +
            item.value +
            "&Tradechannel=Company" +
            "&Moudles=Trade",
        });
        window.open(routeData.href, "_blank");
      } else {
        let routeData = this.$router.resolve({
          path:
            "/index/TradeProduct/TradeDetail/" +
            item.code +
            "/tradeMap/map?id3a=" +
            item.code +
            "&Tradechannel=HsCode" +
            "&Moudles=Trade",
        });
        window.open(routeData.href, "_blank");
      }
    },
    getRankingAndAnalysisStaticDatalist() {
      this.loading = true;
      getTradeTopDataByType({
        aaaid: this.$route.query.id3a,
        dataType: this.menuActive,
      }).then((res) => {
        if (res.code == 200) {
          this.tradeProductRankTop5DTO = res.data.tradeProductRankTop5DTO;
          this.fastGrowthList = res.data.fastGrowthList;
          this.reduceRateList = res.data.reduceRateList;
          if (this.tradeProductRankTop5DTO) {
            this.tradeProductRankTop5DTO.map((item) => {
              let countryImg = this.getCountryImgUrl(item.code);
              item.img = require("../../../../../static" + countryImg);
            });
          }
          if (this.fastGrowthList) {
            this.fastGrowthList.map((item) => {
              let countryImg = this.getCountryImgUrl(item.code);
              item.img = require("../../../../../static" + countryImg);
            });
          }
          if (this.reduceRateList) {
            this.reduceRateList.map((item) => {
              let countryImg = this.getCountryImgUrl(item.code);
              item.img = require("../../../../../static" + countryImg);
            });
          }
          this.loading = false;
        } else {
          this.loading = false;
        }
      });
    },
    MenuClick(item) {
      this.menuActive = item.value;
      this.getRankingAndAnalysisStaticDatalist();
    },
    // 进度条百分比
    getProgress(item) {
      try {
        let tempData =
          (Number(item.totalAmount) / Number(item.totalAmount)) * 100;
        if (tempData > 0 && tempData <= 100) {
          return tempData;
        } else {
          return 0;
        }
      } catch (error) {
        return 0;
      }
    },

    getgetTabListOneLayerLsit() {
      getTabListOneLayer({
        aaaId: this.$route.query.id3a,
        moduleId: 900,
      }).then((res) => {
        if (res.code == 200) {
          this.suppliersFlag = res.data.find(
            (item) => item.name == "company_trade_ranking_suppliers",
          ).isShow;
          this.buyersFlag = res.data.find(
            (item) => item.name == "company_trade_ranking_buyers",
          ).isShow;
          this.originFlag = res.data.find(
            (item) => item.name == "company_trade_ranking_origin",
          ).isShow;
          this.destinationFlag = res.data.find(
            (item) => item.name == "company_trade_ranking_destination",
          ).isShow;
          this.importFlag = res.data.find(
            (item) => item.name == "company_trade_ranking_import_products",
          ).isShow;
          this.exportFlag = res.data.find(
            (item) => item.name == "company_trade_ranking_export_products",
          ).isShow;

          this.menuActive = this.suppliersFlag
            ? 3
            : this.buyersFlag
            ? 4
            : this.originFlag
            ? 5
            : this.destinationFlag
            ? 6
            : this.importFlag
            ? 1
            : 2;
          var arr = {
            value: this.menuActive,
          };
          this.MenuClick(arr);
        }
      });
    },
    getCountryImg() {},
  },
  computed: {
    managementMenu() {
      return [
        {
          label: this.$t("SearchTrade.Suppliers"),
          value: "3",
        },
        {
          label: this.$t("SearchTrade.Buyers"),
          value: "4",
        },
        {
          label: this.$t("SearchTrade.Origin"),
          value: "5",
        },
        {
          label: this.$t("SearchTrade.Destination"),
          value: "6",
        },
        {
          label: this.$t("SearchTrade.ImportProducts"),
          value: "1",
        },

        {
          label: this.$t("SearchTrade.ExportProducts"),
          value: "2",
        },
      ];
    },
  },
  mounted() {
    this.getgetTabListOneLayerLsit();
    this.getRankingAndAnalysisStaticDatalist();
  },
};
</script>
<style scoped>
.operations-head {
  color: #009ea7;
}
.operations-box-head {
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.operations-box-center {
  padding: 30px 40px;
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
}

.operations-box-center-left {
  background: #f5f5f5ff;
  padding: 20px;
  width: 50%;
  padding-bottom: 0rem;
}

.operations-box-center-headr {
  font-family: "Arial Bold";
  font-weight: normal;
  font-size: 18px;
  color: #009ea7;
  margin-bottom: 20px;
}

.TopPorts {
  font-family: "Arial Bold";
  font-weight: normal;
  font-size: 1.285714285714286rem;
  color: #1a2332;
  line-height: 1.6428571428571428rem;
}

.Byshipments {
  font-weight: bold;
  font-size: 18px;
  font-family: "Arial Bold";
  margin-bottom: 20px;
  font-weight: normal;
}
.flex_center_between_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.line_step {
  margin-bottom: 15px;
  font-size: 14px;
}

.line_step .line_title {
  display: flex;
  justify-content: start;
  align-items: center;
  width: 52%;
  overflow: hidden;
  font-size: 14px;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.2857142857142858rem;
}
.line_title:hover {
  cursor: pointer;
  text-decoration: underline;
  color: #009ea7;
}
.blue_num {
  display: block;
  text-align: right;
  color: #009ea7;
  font-size: 14px;
}

.line_step /deep/.el-progress {
  margin-top: 10px;
}

/* edit */
.operations-content {
  height: 100%;
}

::v-deep .el-progress-bar__innerText {
  font-size: 1rem;
  color: #ffffff !important;
}

.Data-Management-ul {
  padding: 5px 20px;
  background: #f5f5f5;
  border-radius: 10px;
  width: max-content;
}

.Data-Management-ul li {
  padding: 10px 20px;
  cursor: pointer;
}

.menuActiveColor {
  background: #ffffff;
  border-radius: 10px;
}
.flex_center_bewTwo .line_step .line_title {
  text-decoration-line: none !important;
  color: #1a2332;
}
.line_img {
  height: 34px;
}
/deep/ .el-scrollbar__wrap {
  max-width: 21rem !important;
}
.font26 {
  font-size: 26px !important;
}
@media (max-width: 1920px) {
  .operations-box-center {
    padding: 22px 30px;
  }

  .Data-Management-ul li {
    padding: 7px 15px;
  }
  .Data-Management-ul {
    padding: 4px 15px;
  }
  .Byshipments {
    font-size: 16px;
    margin-bottom: 15px;
  }
  .operations-box-head {
    gap: 15px;
  }
  .operations-box-center-left {
    padding: 15px;
  }
  .operations-box-center-headr {
    font-size: 16px;
    margin-bottom: 15px;
  }
  .line_img {
    height: 26px;
  }
  .line_step {
    margin-bottom: 12px;
    font-size: 12px;
  }
  .line_step /deep/.el-progress {
    margin-top: 7px;
  }
  .font26 {
    font-size: 20px !important;
  }
}

@media screen and (max-width: 1439px) {
  .operations-box-center {
    padding: 20px 26px;
  }

  .Data-Management-ul li {
    padding: 6px 13px;
  }
  .Data-Management-ul {
    padding: 3px 13px;
  }
  .Byshipments {
    font-size: 14px;
    margin-bottom: 13px;
  }
  .operations-box-head {
    gap: 12px;
  }
  .operations-box-center-left {
    padding: 12px;
  }
  .operations-box-center-headr {
    font-size: 14px;
    margin-bottom: 12px;
  }
  .line_img {
    height: 22px;
  }
  .line_step {
    margin-bottom: 10px;
  }
  .line_step /deep/.el-progress {
    margin-top: 6px;
  }
  .font26 {
    font-size: 18px !important;
  }
}
</style>
